<span class="tag" [matTooltip]="tooltip()" [class.has-icon]="icon">
  @if (icon) {
    <mat-icon [class.mat-icon-rtl-mirror]="rtlMirrorIcon()" [svgIcon]="icon" muloSvgViewbox></mat-icon>
  }
  <ng-content></ng-content>
</span>
@if (description) {
  <span class="description">{{ description }}</span>
}
